<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;" class="fontMS700 colorPrincipal font-45 mt-3">
            RICARDO PALMA <br>
            <span style="line-height: 100%;" class="fontMS300">
                GUARDIÁN DEL PATRIMONIO <br>
                EN EL CAMBIO DE SIGLO<br>
            </span>
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio19/ricardo-palma">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio19/ricardo-palma">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio19/ricardo-palma">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img class="img_portada" src="/assets/images/micrositio/micrositio19/RP_000.jpg">
</section>

<div class="fondoBlanco_Intro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS500 font-24 text-center">
                    RICARDO PALMA, PERIODISTA Y LITERATO, ES DESIGNADO DIRECTOR DE LA 
                    BIBLIOTECA NACIONAL, LUEGO DEL NOMBRAMIENTO DE MIGUEL IGLESIAS COMO 
                    PRESIDENTE DE LA REPÚBLICA Y LA FIRMA DEL TRATADO DE ANCÓN EN 1883. 
                    INICIÓ UNA IMPORTANTE GESTIÓN PARA LA RECONSTRUCCIÓN DE LA BIBLIOTECA 
                    TRAS EL SAQUEO DURANTE LA OCUPACIÓN DE LIMA POR PARTE DEL EJÉRCITO 
                    CHILENO DURANTE LA GUERRA DEL PACÍFICO. 
                </p>
            </div>
            <div class="col-sm-12">
                <p class="fontMS100 text-justify font-24 text-gris mt-5 mb-3">
                    Ricardo Palma se mantuvo en el cargo de director de la Biblioteca por un período de veintiocho años. 
                    En ese tiempo logró reorganizar la institución, incrementó sus fondos, intensificó su carácter patrimonial 
                    y le correspondió convertirse en el empleado público con mayor ascendencia cultural de la nación de fines 
                    del siglo diecinueve y las primeras décadas del siglo XX 
                    <br>
                    <br>
                </p>
            </div>
            <div class="col-sm-12 img_caricatura libro">
                <a href="https://hdl.handle.net/20.500.14428/70965" target="_blank" style="color: black;">
                    <img src="/assets/images/micrositio/micrositio19/RP_001.jpg" width="100%">
                    <div class="overlay-img2">
                        <p class="fontMS100">Caricatura de Ricardo Palma</p>
                    </div>
                </a>
            </div>
            <br>
            <p class="fontMS100 text-center font-20 text-gris">
                <br>
                Caricatura de Ricardo Palma por CAO
                <br><br>
            </p>
        </div>
    </div>
</div>
<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="c100">
                    <img class="lineCel mt-3" width="100%"
                        src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada5.png">
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal2 font-40">
                    LAS MEMORIAS DE LA RECUPERACIÓN<br>
                </p>
                <div class="row">
                    <div class="col-sm-2" style="padding:0%; margin-top: 1%;">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada5.png">
                    </div>
                    <div class="col-sm-8" style="padding:0%">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS300 text-center colorPrincipal2 font-40">
                            DE LA BIBLIOTECA NACIONAL
                        </p>
                    </div>
                    <div class="c100">
                        <img class="lineCel mb-3" width="100%" 
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada5.png">
                    </div>
                    <div class="col-sm-2" style="padding:0%; margin-top: 1%;">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada5.png">
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p class="fontMS500 text-center text-white font-24 p2">
                            RICARDO PALMA FUE EL PRIMER DIRECTOR DE LA BIBLIOTECA NACIONAL EN PRESENTAR MEMORIAS 
                            INSTITUCIONALES. ESTOS DOCUMENTOS, PUBLICADOS ENTRE 1884 Y 1912, DAN A CONOCER ASPECTOS 
                            ESENCIALES DE SU GESTIÓN COMO, POR EJEMPLO, LAS ACCIONES EFECTUADAS PARA RECUPERAR LOS 
                            FONDOS BIBLIOGRÁFICOS Y DOCUMENTALES, LA ADQUISICIÓN DE IMPORTANTES COLECCIONES COMO LA 
                            DE FERNANDO CASÓS, LA UNIFICACIÓN DE LA BIBLIOTECA NACIONAL Y EL ARCHIVO NACIONAL, 
                            LA CREACIÓN DE UNA SECCIÓN ESPECIAL DE PERIÓDICOS Y LA APROBACIÓN DE NORMAS ADMINISTRATIVAS 
                            REFERIDAS AL INGRESO A LAS SALAS DE LECTURA Y EL USO DE LAS DIFERENTES COLECCIONES.
                            <br><br>
                        </p>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-sm-12 libro-horizontal">
                        <a href="http://hdl.handle.net/20.500.14428/79197" target="_blank" style="color: black;">
                            <img class="p2" width="100%" 
                                src="/assets/images/micrositio/micrositio19/RP_002.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    Palma realizó anotaciones de puño y letra en márgenes de obras y manuscritos 
                                    existentes en los repositorios de la misma BNP 
                                </p>
                            </div>
                        </a>
                        <p class="fontMS100Italic font-20 text-white">
                            <br>
                            Ricardo Palma en su oficina en la Biblioteca Nacional hacia 1908
                        </p>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-sm-4 libro-small-3 mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/14796" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio19/RP_003.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    Memoria de la Nueva Biblioteca Nacional, 1884. 
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro-small-3 mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/21344" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio19/RP_004.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    En la Memoria de 1890-1892 
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro-small-3 mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/21345" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio19/RP_005.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    En la Memoria de 1896 
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-sm-4 libro-small-3 mt-3">
                        <a href="http://hdl.handle.net/20.500.14428/79578" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio19/RP_006.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    En la Memoria de 1898
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro-small-3 mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/21563" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio19/RP_007.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    Ricardo Palma reclama en las Memorias de 1902, 1905-1906, 1909, 1910 y 1911 
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro-small-3 mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/21561" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio19/RP_008.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    Memoria que presenta el Director de la Biblioteca Nacional en la que compendia 25 años de labor (1908) 
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-12">

                <div class="c100">
                    <img class="lineCel mt-3" width="100%"
                        src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                </div>
                <p style="line-height: 160%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal font-40">
                    LOS LAZOS CULTURALES DE PALMA
                </p>
                
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                            class="fontMS300 text-center colorPrincipal font-40">
                            A PARTIR DE LAS CARTAS
                        </p>
                    </div>
                    <div class="c100">
                        <img class="lineCel mb-3" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada3.png">
                    </div>
                </div>
                
                
                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p class="fontMS500 font-24 text-center">
                            PRESENTAMOS UNA SELECCIÓN DE LA CORRESPONDENCIA MANTENIDA ENTRE RICARDO PALMA Y LOS 
                            DIFERENTES PRESIDENTES DE LA REPÚBLICA, ALGUNOS MIENTRAS EJERCÍAN EL CARGO, OTROS CUANDO 
                            ERAN FUNCIONARIOS PÚBLICOS ANTES DE ALCANZAR SU INVESTIDURA. LOS DOCUMENTOS SON TESTIMONIO 
                            DE LA RELACIÓN ENTRE LA PRIMERA INSTITUCIÓN CULTURAL DE LA NACIÓN Y EL ESTADO PERUANO, 
                            Y LA FIGURA DE SU DIRECTOR CON LAS PRINCIPALES FIGURAS DEL PODER POLÍTICO.
                        </p>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-sm-4 libro-small-3 mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/37684" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio19/RP_009.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    Nota de Domingo de Santa María, presidente de Chile, a Ricardo Palma. 1886. 
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro-small-3 mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/45813" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio19/RP_010.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    Carta de Un Bibliófilo a Ricardo Palma. Lima, 30 de mayo de 1895.
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro-small-3 mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/22466" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio19/RP_011.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    Carta de José Toribio Medina. Santiago, 10(?) de diciembre de 1895.  
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-sm-4 libro-small-3 mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/23851" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio19/RP_012.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    Carta de Eduardo Benot, político, escritor, matemático y lingüista español. Madrid, 26 de febrero de 1896
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro-small-3 mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/47752" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio19/RP_013.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    Carta de Matías León, Ministro de Justicia, Instrucción y Culto. [Lima], 4 de noviembre de 1909. 
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro-small-3 mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/45820" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio19/RP_014.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    Carta de Robert Lehmann-Nitsche. [La Plata], 5 de diciembre de 1912. 
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
                <br><br><br><br>
                <img width="100%" src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA2.jpg">
                <br><br><br><br>
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada3.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel mb-3" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            UNA INSISTENTE LABOR
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada3.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal font-40">
                    CORRESPONDENCIA CON LOS PRESIDENTES
                </p>
                <div class="c100">
                    <img class="lineCel mt-3" width="100%"
                        src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                </div>
                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p class="fontMS500 font-24 text-center">
                            EL ESFUERZO REALIZADO POR PALMA PARA RECONSTITUIR LA INSTITUCIÓN SE PUEDE 
                            VISIBILIZAR A TRAVÉS DE LA COMUNICACIÓN EPISTOLAR SOSTENIDA CON EL OBJETIVO 
                            DE CONSEGUIR FONDOS BIBLIOGRÁFICOS PARA LA EXPOLIADA BIBLIOTECA. EN EL AÑO 2020, 
                            EL MINISTERIO DE CULTURA DECLARÓ PATRIMONIO CULTURAL DE LA NACIÓN A LAS 407 
                            UNIDADES DOCUMENTALES DE SU CORRESPONDENCIA EN CUSTODIA DE LA BIBLIOTECA NACIONAL 
                            DEL PERÚ EN CONSIDERACIÓN A SU RELEVANCIA. 
                        </p>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-sm-4 libro-small-3 mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/15949" target="_blank" style="color: black;">
                            <img class="p2" width="100%" 
                                src="/assets/images/micrositio/micrositio19/RP_015.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    Invitación de Manuel Candamo, Presidente de la Comisión Diplomática del Congreso, a Ricardo Palma. Lima, 7 de setiembre de 1893.
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro-small-3 mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/22826" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio19/RP_016.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    Carta de José Pardo a Ricardo Palma. Lima, 10 de abril de 1905 
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro-small-3 mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/23519" target="_blank" style="color: black;">
                            <img class="p2" width="100%" 
                                src="/assets/images/micrositio/micrositio19/RP_017.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    Carta de José Pardo a Ricardo Palma. Lima, 27 de noviembre de 1905
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-4 libro-small-3 mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/70354" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio19/RP_018.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    Carta de Ricardo Palma a Nicolás de Piérola. Lima, 29 de mayo de 1881
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro-small-3 mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/37625" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio19/RP_019.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    Carta de José Pardo a Ricardo Palma. Madrid, 22 de febrero de 1889
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro-small-3 mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/19847" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio19/RP_020.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    Carta de Guillermo Billinghurst a Ricardo Palma. Iquique, 7 de diciembre de 1891
                                </p>
                            </div>
                        </a>
                    </div>
                    
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3 libro-small-3 mt-3">
                <a href="https://hdl.handle.net/20.500.14428/32506" target="_blank" style="color: black;">
                    <img class="p2" width="100%" height="100%"
                        src="/assets/images/micrositio/micrositio19/RP_021.jpg">
                    <div class="overlay">
                        <p class="fontMS100 text-center">
                            Carta de Andrés A. Cáceres a Ricardo Palma. París, enero 28 de 1892 
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-3 libro-small-3 mt-3">
                <a href="https://hdl.handle.net/20.500.14428/44457" target="_blank" style="color: black;">
                    <img class="p2" width="100%" height="100%"
                        src="/assets/images/micrositio/micrositio19/RP_022.jpg">
                    <div class="overlay">
                        <p class="fontMS100 text-center">
                            Carta de Remigio Morales Bermúdez a Ricardo Palma. Lima, diciembre 19 de 1892
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-3 libro-small-3 mt-3">
                <a href="https://hdl.handle.net/20.500.14428/23058" target="_blank" style="color: black;">
                    <img class="p2" width="100%" height="100%"
                        src="/assets/images/micrositio/micrositio19/RP_023.jpg">
                    <div class="overlay">
                        <p class="fontMS100 text-center">
                            Carta de Eduardo López de Romaña a Ricardo Palma. Lima, 11 de febrero de 1901.
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-3 libro-small-3 mt-3">
                <a href="https://hdl.handle.net/20.500.14428/21881" target="_blank" style="color: black;">
                    <img class="p2" width="100%" height="100%"
                        src="/assets/images/micrositio/micrositio19/RP_024.jpg">
                    <div class="overlay">
                        <p class="fontMS100 text-center">
                            Carta de Manuel Candamo a Ricardo Palma. Lima, 3 de diciembre de 1903
                        </p>
                    </div>
                </a>
            </div>
        </div>
    </div>
</div>

<div class="container_Azul">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img width="100%" src="\assets\images\general\LINEA_RESALTE_BLANCA.png">
                <br><br><br>
                <p class="fontMS500 text-white text-justify font-24">
                    &laquo;EN NUESTRA CUESTIÓN DE LÍMITES CON LA VECINA REPÚBLICA DEL
                    ECUADOR, QUE PARECE YA SOLUCIONADA CONVENIENTEMENTE PARA
                    AMBOS PAÍSES, HA CORRESPONDIDO A LA BIBLIOTECA DE LIMA PARTE, Y
                    NO PEQUEÑA, EN EL ÉXITO. LIBROS DE CONSULTA, MAPAS, RELACIONES
                    INÉDITAS DE VIAJEROS Y DOCUMENTOS DECISIVOS, CUYA PRESENCIA SE
                    NEGARA Y QUE SE ENCONTRARA EN LA SECCIÓN DE MANUSCRITOS, TODO
                    HA SIDO PUESTO A DISPOSICIÓN DEL MINISTERIO DE RELACIONES
                    EXTERIORES, QUE HA RECONOCIDO LA IMPORTANCIA DEL SERVICIO
                    PRESTADO POR EL ESTABLECIMIENTO&raquo; <br>
                </p>
                <div class="col-sm-12 text-right">
                    <span class="fontMS300Italic text-white font-24">RICARDO PALMA.<br>
                        MEMORIA DE LA BIBLIOTECA NACIONAL, 1888-1890<br><br></span>
                </div>
                <img id="img_rotate" src="\assets\images\general\LINEA_RESALTE_BLANCA.png">
            </div>
        </div>
    </div>
</div>



<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3" style="padding:0%">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada3.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel mb-3" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                    <div class="col-sm-6" style="padding:0%">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            LAS OBSERVACIONES <br>
                        </p>
                    </div>
                    <div class="col-sm-3" style="padding:0%">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada3.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS300 text-center colorPrincipal font-40">
                    MARGINALES DE PALMA
                </p>
                <div class="c100">
                    <img class="lineCel mt-3" width="100%"
                        src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                </div>
                <div class="row mt-5">
                    <div class="row">
                        <div class="col-sm-6 libro pd-5">
                            <a href="http://hdl.handle.net/20.500.14428/79216"
                             target="_blank" style="color: black;">
                                <img width="100%"
                                    src="/assets/images/micrositio/micrositio19/RP_025.jpg">
                                <div class="overlay-img1">
                                    <p class="fontMS100 text-center">
                                        Palma realizó anotaciones de puño y letra en márgenes de obras y manuscritos 
                                        existentes en los repositorios de la misma BNP 
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6">
                            <p class="fontMS500 font-24">
                                PALMA REALIZÓ ANOTACIONES DE 
                                PUÑO Y LETRA EN MÁRGENES DE 
                                OBRAS Y MANUSCRITOS EXISTENTES EN 
                                LOS REPOSITORIOS DE LA MISMA BNP, 
                                SIENDO UNA PRÁCTICA HABITUAL E 
                                INÉDITA PARA EL CARGO DE DIRECTOR. 
                                <br>
                            </p>
                            <!--<p class="fontMS100 font-24 text-gris">
                                Posteriormente, en su Nota Informativa, Manuel González Prada, el siguiente director, realiza
                                una amarga crítica a estas apostillas.
                            </p>-->

                            <p class="fontMS100 font-24 text-gris">
                                Ricardo Palma al asumir la tarea de reorganizar la Biblioteca Nacional, se propuso conocer 
                                prácticamente todos los documentos y ediciones que recopiló, hecho que se hizo patente en 
                                las numerosas anotaciones que efectuó en manuscritos, libros, correspondencia, entre otros.
                                <br>
                            </p>
                            <p class="fontMS100 font-24 text-gris">
                                El contenido de las glosas o apostillas era variado, tanto en el tono como en el tipo de 
                                comentario. En algunos casos expresaban algún juicio sobre el valor del documento. En otros, 
                                daba a conocer su apreciación sobre el estilo, estructura y contenido de las obras 
                                literarias revisadas. Del mismo modo, anotaba datos adicionales sobre los autores, 
                                personajes o temas de los materiales analizados así como datos interesantes sobre 
                                el origen o historia del documento, tal como se puede apreciar en el Opus pulcherrimuz 
                                chiromantie que forma parte de esta sección. 
                                <br>
                            </p>
                            <p class="fontMS100 font-24 text-gris">
                                Autores como Roy Tanner, resaltan las apostillas de Palma, las que «demuestran el gran amor
                                que tenía por la Biblioteca Nacional —su biblioteca— y el orgullo que sentía por el papel 
                                que desempeñaba en su restauración y avance. Iluminan la abnegación con que don Ricardo 
                                cargaba con la responsabilidad que se le había otorgado y abren una ventana sobre ciertos 
                                procedimientos seguidos por Palma en la administración de la dirección». 
                            </p>
                        </div>
                    </div>
                </div>
                <br><br><br>
                <!--<div class="row">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-center font-24 text-gris">
                            Posteriormente, en su Nota Informativa, Manuel González Prada, el siguiente director, realiza
                            una amarga crítica a estas apostillas.
                        </p>
                    </div>
                </div>-->
                <div class="row mt-5">
                    <div class="col-sm-6 libro2 mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/13008" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio19/RP_026.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    Opus pulcherrimuz chiromantie cum multis additi?bus nouiter impressuz. 
                                    Venetiis: Bernandinum Benali?, 1499
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-6 libro2 mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/13066" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio19/RP_027.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    Doctrina christiana, y catecismo para instrvcción de los indios, 
                                    y de las de mas persfonas, que han de fer enfeñadas en nueftra sancta fé ... 
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-3" style="padding:0%">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%" style="margin-bottom: 2%;"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-4" style="padding:0%">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            LA RENUNCIA <br>
                        </p>
                    </div>
                    <div class="col-sm-3" style="padding:0%">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                    <div class="col-sm-1"></div>
                </div>
                <div class="c100">
                    <img class="lineCel" width="100%" style="margin-top: 2%;"
                        src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA1-recortada.png">
                </div>
                <br><br>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="fontMS500 text-center font-24">
                            EN 1912 RICARDO PALMA RENUNCIA A LA DIRECCIÓN DE LA BIBLIOTECA
                            NACIONAL POR DESENCUENTROS CON EL PRESIDENTE AUGUSTO B. LEGUÍA,
                            SIENDO NOMBRADO COMO SU SUCESOR MANUEL GONZÁLEZ PRADA.
                            <br><br>
                        </p>
                        <p class="fontMS100 text-center font-20 text-gris">
                            Este hecho representó un punto de quiebre en el medio cultural de la época, en la medida 
                            que, como señala Osmar Gonzales, «mientras Palma pertenecía a una tradición cultural 
                            romántica y a una visión social de tipo restringida, González Prada se ubicaba en una 
                            tradición cultural intelectualista y en una visión social no restringida (…). Ambas, 
                            tradiciones culturales y visiones sociales, dan sentido a una forma de ver la vida, 
                            el papel de los intelectuales, la cultura y la política». Más aún, ambos representan 
                            dos visiones diversas acerca de lo que es —y debe ser— la Biblioteca Nacional y su relación 
                            con la ciudadanía. 
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3" style="padding:0%">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%" style="margin-bottom: 2%;"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6" style="padding:0%">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            MEMORIA FOTOGRÁFICA <br>
                        </p>
                    </div>
                    <div class="col-sm-3" style="padding:0%">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                </div>
                <p style="line-height: 160%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal font-40">
                    DE RICARDO PALMA <br>
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%" style="margin-top: 2%;"
                        src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA1-recortada.png">
                </div>
                <br><br>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="fontMS500 font-24 text-center">
                            LA BIBLIOTECA NACIONAL CONSERVA DOS ÁLBUMES DE FOTOGRAFÍAS DE
                            RICARDO PALMA CON UNA DATACIÓN APROXIMADA DE 1917 Y 1936,
                            RESPECTIVAMENTE.
                        </p>
                    </div>
                    <div class="col-sm-6 libro-horizontal-small2 mt-3">
                        <a href="http://hdl.handle.net/20.500.14428/79596" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                              src="/assets/images/micrositio/micrositio19/RP_028.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    Álbum de Ricardo Palma I, fotografías personales, familiares y de homenajes 
                                    póstumos desde 1864 a 1919
                                </p>
                            </div>
                         </a>
                    </div>
                    <div class="col-sm-6 libro-horizontal-small2 mt-3">
                        <a href="http://hdl.handle.net/20.500.14428/79593" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio19/RP_029.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    Álbum de Ricardo Palma II, homenajes póstumos durante la década de 1930
                                </p>
                            </div>
                         </a>
                    </div>
                </div>
                <br>
                <div class="row mt-3">
                    <div class="col-sm-6">
                        <p class="fontMS100 font-20 text-gris font-italic">
                            Álbum de Ricardo Palma I, fotografías
                            personales, familiares y de homenajes
                            póstumos desde 1864 a 1919.
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100 font-20 text-gris font-italic">
                            Álbum de Ricardo Palma II, homenajes
                            póstumos durante la década de 1930.
                        </p>
                    </div>
                </div>
                <br><br><br>
                <img width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                <br><br><br>
                <div class="row">
                    <div class="col-sm-4 libro mt-3">
                        <a href="http://hdl.handle.net/20.500.14428/79203" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio19/RP_030.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    Retrato de Ricardo Palma, 1902
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro mt-3">
                        <a href="http://hdl.handle.net/20.500.14428/79204" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio19/RP_031.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    Retrato de Ricardo Palma, hacia 1864
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro mt-3">
                        <a href="http://hdl.handle.net/20.500.14428/79205" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio19/RP_032.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    Retrato de Ricardo Palma con la medalla de la Real Academia de la Lengua, hacia 1886
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-6 libro-ovalado mt-3">
                        <a href="http://hdl.handle.net/20.500.14428/79202" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%" style="padding:5%;"
                                src="/assets/images/micrositio/micrositio19/RP_033.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    Retrato de Ricardo Palma, 1888
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-6 libro-horizontal-small mt-3">
                        <a href="http://hdl.handle.net/20.500.14428/79207" target="_blank" style="color: black;">
                            <img class="p2 img_retrato3" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio19/RP_034.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    Retrato coloreado de Ricardo Palma en la Biblioteca Nacional hacia 1907
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-6 libro-horizontal-small2 mt-3">
                        <a href="http://hdl.handle.net/20.500.14428/79206" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio19/RP_035.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    De izquierda a derecha: Clemente Palma, sentado Ricardo Palma, Angélica Palma R., 
                                    Félix Vital Palma R., sentada su esposa Cristina Román, Ricardo Palma R., Peregrina 
                                    Palma R. y sentada Réene Cristina Palma R. 1902
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-6 libro-horizontal-small2 mt-3">
                        <a href="http://hdl.handle.net/20.500.14428/79209" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio19/RP_036.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    Homenaje de desagravio a Ricardo Palma al ser destituido en la Biblioteca Nacional (1912)
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-6 libro-horizontal-small2 mt-3">
                        <a href="http://hdl.handle.net/20.500.14428/79210" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio19/RP_037.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    Ricardo Palma y otros intelectuales en la visita de Roque Sáenz Peña. 1905
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-6 libro-horizontal-small2 mt-3">
                        <a href="http://hdl.handle.net/20.500.14428/79211" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio19/RP_038.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    Ricardo Palma, hijos y nietos. 1912
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="container_Morado">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-3">
                        <p style="line-height: 130%;margin-bottom: 0%;" class="fontMS500 text-white font-40">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-9">
                        <img id="img_dialogo"
                            src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU_LINEA_DIALOGO1.png">
                    </div>
                </div>
                <p class="text-white text-justify font-24">
                    Te proponemos leer la Memoria de la Nueva Biblioteca Nacional (1884-1888) y las cartas en la que 
                    Ricardo Palma compartió sus principales acciones y su visión sobre la biblioteca.  
                </p>
                <div class="row">
                    <div class="col-sm-4 p-3">
                        <p class="fontMS500 text-white font-24">
                            Ricardo Palma considera que los verdaderos lectores de la Biblioteca Nacional 
                            son «personas que no buscan libros de solaz o entretenimiento sino positivas obras 
                            de consulta; hombres, en fin, que aspiran a ensanchar el caudal de sus conocimientos». 
                            ¿Qué opinas al respecto? 
                        </p>
                        <img class="c100 mt-3" width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                    </div>
                    <div class="col-sm-4 p-3">
                        <p class="fontMS500 text-white font-24">
                            En sus cartas Ricardo Palma comenta las acciones para la protección y difusión del 
                            patrimonio documental bibliográfico. Al respecto, ¿cuáles fueron principales problemas 
                            que Palma atravesó para realizar dicha labor?
                        </p>
                        <img class="c100 mt-3" width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                    </div>
                    <div class="col-sm-4 p-3">
                        <p class="fontMS500 text-white font-24">
                            Te invitamos a responder una de las cartas que Ricardo Palma, en su calidad de director 
                            de la Biblioteca Nacional, envía a las autoridades del Estado. ¿Qué soluciones le plantearías?
                        </p>
                        <img class="c100 mt-3" width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <img class="bottom_cel" width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                    </div>
                    <div class="col-sm-4">
                        <img class="bottom_cel" width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                    </div>
                    <div class="col-sm-4">
                        <img class="bottom_cel" width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel mb-3" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                    <div class="col-sm-4 text-center">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel mt-3" width="100%"
                            src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                </div>
                <p class="fontMS100 font-24">
                    <br><br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Gonzales, O. (2001-2002) </span><br>
                            <span class="fontMS100Italic text-gris">Ricardo Palma y Manuel González Prada:
                                conflicto entre dos tipos de intelectuales.<br>
                                Fénix.<br>
                            </span>
                            <span class="text-gris">Revista de la Biblioteca Nacional del Perú. No.
                                43-44, p. 79-98.</span><br>
                            <a href="http://revistafenix.bnp.gob.pe/index.php/fenix/article/view/43/1193 " target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Gonzales, O. (2009)</span><br>
                            <span class="fontMS100Italic text-gris">La correspondencia de Ricardo Palma. </span>
                            <span class="text-gris">Contribuciones desde Coatepec. No. 16, p.
                                183-200.</span><br>
                            <a href="https://www.redalyc.org/pdf/281/28112196010.pdf " target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Hampe, T. (2012)</span><br>
                            <span class="fontMS100Italic text-gris">Nuevo asedio al “bibliotecario mendigo”:
                                Ricardo Palma en la Biblioteca Nacional. </span>
                            <span class="text-gris">Bibliographica americana: Revista
                                Interdisciplinaria de Estudios Coloniales.
                                No. 8, p. 330-344. </span><br>
                            <a href="https://www.bn.gov.ar/micrositios/revistas/bibliographica/bibliographica-americana-3"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Palma, R. (2005)</span>
                            <span class="fontMS100Italic text-gris"> Epistolario general. Edición, prólogo, notas e
                                índices, Miguel Ángel Rodríguez Rea.<br>
                            </span>
                            <span class="text-gris"> Lima: Universidad Ricardo Palma, Editorial
                                Universitaria. </span><br>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=294823" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Tanner, R. (1992) </span><br>
                            <span class="fontMS100Italic text-gris">Las anotaciones marginales de Ricardo Palma
                                en la Biblioteca Nacional. Actas del X
                                Congreso de la Asociación Internacional de
                                Hispanistas. Barcelona, 21-26 de agosto de
                                1989. </span><br>
                            <span class="text-gris">Barcelona: Promociones y Publicaciones
                                Universitarias, p. 1017-1024. </span><br>
                            <a href="http://www.cervantesvirtual.com/obra/las-anotaciones-marginales-de-ricardo-palma-en-la-biblioteca-nacional/" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Kapsoli, W. (2019) </span><br>
                            <span class="text-gris">La correspondencia entre Ricardo Palma y
                                Nicolás de Piérola. Aula Palma. No. 17, p.
                                35-58.</span><br>
                            <a href="https://revistas.urp.edu.pe/index.php/Aula_Palma/article/view/2121/2144"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


